import React, { useCallback } from 'react'
import styled from 'styled-components/macro'
import { useDropzone } from 'react-dropzone'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import FileList from './FileList'

const UnderlinedText = styled.span`
  text-decoration: underline;
`

const ONE_MB = 1000000

function FileAttachDropzone({
  files,
  onChange,
  error,
  disabled,
  display,
  setFieldError,
  name = 'file',
  onRemove,
  multiple = true,
}) {
  const onDrop = useCallback(
    (acceptedFiles, rejectedFiles) => {
      if (rejectedFiles.length > 0) {
        const rejectedFile = rejectedFiles[0]

        if (rejectedFile) setFieldError(name, rejectedFile.errors?.[0]?.message)
      } else {
        onChange(acceptedFiles)
      }
    },
    [onChange]
  )

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: 'application/pdf',
    maxSize: 100 * ONE_MB,
    multiple,
  })

  return (
    <>
      <Box component="label">{display}</Box>
      <Box
        component="div"
        {...getRootProps()}
        sx={{
          width: '100%',
          border: '1px solid',
          borderColor: error ? 'error.main' : 'lightgray.main',
          bgcolor: 'lightgray.light',
          borderRadius: '4px',
          display: 'flex',
          userSelect: 'none',
          cursor: 'pointer',
          flexDirection: 'column',
          py: 4,
        }}
      >
        {!disabled && <Box component="input" {...getInputProps()} />}
        {!files?.length ? (
          <Box sx={{ width: '50%', m: 'auto', textAlign: 'center' }}>
            <Box>
              <CloudUploadIcon sx={{ color: 'darkgray.main' }} />
              <Typography color="darkgray.main">
                Drag and drop {multiple ? 'pdfs' : 'pdf'} here or{' '}
                <UnderlinedText>browse files</UnderlinedText>
              </Typography>
            </Box>
          </Box>
        ) : (
          <FileList files={files} onRemove={onRemove} />
        )}
      </Box>
      {error && (
        <Typography color="error.main" sx={{ mt: '1px' }}>
          {error}
        </Typography>
      )}
    </>
  )
}

export default FileAttachDropzone
